module.exports = __webpack_public_path__ + "img/google.6361f7fd.svg";